import * as AppConstants from 'app/AppConstants';

const initialState = () => ({
  preferences: {},
});

export default (state = initialState(), action) => {
  switch (action.type) {
    case AppConstants.PREFERENCE__SAVED_PREFERENCES:
    case AppConstants.PREFERENCE__LOADED_PREFERENCES: {
      return {
        ...state,
        preferences: action.payload.preferences,
      };
    }

    default:
      return state;
  }
};
